<template>
  <v-container class="mt-12 pt-0" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="pa-0 px-0">
          <v-col cols="12" class="py-0 px-0 mx-0" SPLASH>
            <v-card color="primary"  flat tile dark class="splashImage">
              <v-card-text>
                <v-row class="text-center align-center py-12 my-12">
                  <v-col cols="12" md="3">
                    
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-row class="text-center align-center">
                      <v-col cols="12" md="12">
                        <div :class="`${arabic?'arFont':'enFont'} white--text py-3`" style="line-height:36px;font-size:2.0rem;font-weight:bold;" > 
                          {{i18n.its}}
                        </div>
                      </v-col>
                      <v-col cols="12" md="12">
                        <div :class="`${arabic?'arFont':'enFont'} white--text py-3`" style="line-height:1.6;font-size:1.2rem;">
                          {{i18n.its_intro}}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3">
                    
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="false">
            <v-parallax
                dark
                contain
                top
                src="/images/splash3.jpg"
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col
                    class="text-center"
                    cols="12"
                  >
                    <h1 :class="`${arabic?'arFont':'enFont'} text-h4 font-weight-thin mb-4`">
                      {{i18n.its}}
                    </h1>
                    <h4 :class="`${arabic?'arFont':'enFont'} subheading`">
                      {{i18n.its_intro}}
                    </h4>
                  </v-col>
                </v-row>
            </v-parallax>
          </v-col>
          
          <v-col cols="12" LOADING v-if="loading">
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          </v-col>
          <v-col cols="12" LOADING v-if="!loading && user && user.account && user.account.logo" class="text-center py-10">
            <img :src="user.account.logo" height="60" alt="">
          </v-col>
          <v-col cols="12" md="3" STAT v-if="done">
            <MiniStat
              :icon="'emoji_objects'"
              :title="result.one"
              :subTitle="i18n.creativity_problem"
              :color="'primary'"
            />
          </v-col>
          <v-col cols="12" md="3" STAT v-if="done">
            <MiniStat
              :icon="'warning'"
              :title="result.two"
              :subTitle="i18n.risk_taking"
              :color="'primary lighten-2'"
            />
          </v-col>
          <v-col cols="12" md="3" STAT v-if="done">
            <MiniStat
              :icon="'groups'"
              :title="result.three"
              :subTitle="i18n.com_relation"
              :color="'secondary'"
            />
          </v-col>
          <v-col cols="12" md="3" STAT v-if="done">
            <MiniStat
              :icon="'emoji_events'"
              :title="result.three"
              :subTitle="i18n.excution_managment"
              :color="'info'"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="done">
            <v-card outlined>
              <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} subheading secondary--text`">
                {{i18n.result}}
              </v-card-title>
              <v-card-text class="forceArabic text-center">
                <innovationRadar style="width:100%;" :data="chartData" />
              </v-card-text>      
            </v-card>
          </v-col>
          <v-col cols="12" :md="`${done ? '4' : '6'}`" MENU>
            <v-card outlined>
              <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} subheading secondary--text`">
                {{i18n.dashboard}}
              </v-card-title>
              <v-card-text>
                <v-list dense nav v-for="(item, i) in items" :key="'item-' + i" class="specialMenu">
                  <v-list-item v-if="!item.subs" @click="goTo(item.path)">
                    <v-list-item-icon>
                      <v-icon>{{item.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title :class="`${arabic?'arFont':'enFont'}`">{{i18n[item.text]}}</v-list-item-title>
                  </v-list-item>
                  <v-list-group
                    v-model="open[i]"
                    v-if="item.subs"
                    class="specialMenu"
                    dark
                    :prepend-icon="item.icon"
                    append-icon="keyboard_arrow_down"
                  >
                    <template v-slot:activator class="my-0">
                      <v-list-item-title :class="`${arabic?'arFont':'enFont'} my-0 `">{{i18n[item.text]}}</v-list-item-title>
                    </template>
                    <v-list-item
                      v-for="(sub, i) in item.subs"
                      :key="i+'sub'"
                      link
                      @click="goTo(sub.path)"
                    >
                      
                      <v-list-item-title :class="`${arabic?'arFont':'enFont'}`" v-text="i18n[sub.text]"></v-list-item-title>
                      <v-list-item-icon>
                        <v-icon v-text="sub.icon"></v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-card-text>      
            </v-card>
          </v-col>
          
          <v-col cols="12" :md="`${done ? '4' : '6'}`" MENU>
            <v-card outlined>
              <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} subheading secondary--text`">
                {{i18n.notifications}}
              </v-card-title>
              <v-card-text>
                <Notifications :notifications="notifications" />
              </v-card-text>      
            </v-card>
          </v-col>
          <v-col cols="12" class="py-0 px-0 mx-0" FEATURE CARDS>
            <v-card color="#fff" flat tile class="py-7 px-8">
              <v-card-text class="fill-height">
                <v-row class="text-center align-center">
                  <v-col cols="12">
                    <div :class="`${arabic?'arFont':'enFont'}`" style="color:#000;line-height:36px;font-size:2.0rem;font-weight:bold;">
                      {{i18n.speed_up_innovation}}
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" class="px-5" FEATURE>
                    <v-row class="text-center align-center">
                      <v-col cols="12" md="12">
                        <v-icon size="35">check_circle_outline</v-icon>
                      </v-col>
                      <v-col cols="12" md="12">
                        <h3 :class="`${arabic?'arFont':'enFont'} py-3`" style="color:#000;">
                          {{i18n.products_tech_services}}
                        </h3>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" class="px-5" FEATURE>
                    <v-row class="text-center align-center">
                      <v-col cols="12" md="12">
                        <v-icon size="35">check_circle_outline</v-icon>
                      </v-col>
                      <v-col cols="12" md="12">
                        <h3 :class="`${arabic?'arFont':'enFont'} py-3`" style="color:#000;">
                          {{i18n.strategies_values}}
                        </h3>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" class="px-5" FEATURE>
                    <v-row class="text-center align-center">
                      <v-col cols="12" md="12">
                        <v-icon size="35">check_circle_outline</v-icon>
                      </v-col>
                      <v-col cols="12" md="12">
                        <h3 :class="`${arabic?'arFont':'enFont'} py-3`" style="color:#000;">
                          {{i18n.create_lead_stackholders}}
                        </h3>
                      </v-col>
                      
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" class="px-5" FEATURE>
                    <v-row class="text-center align-center">
                      <v-col cols="12" md="12">
                        <v-icon size="35">check_circle_outline</v-icon>
                      </v-col>
                      <v-col cols="12" md="12">
                        <h3 :class="`${arabic?'arFont':'enFont'} py-3`" style="color:#000;">
                          {{i18n.marketing_efficiency}}
                        </h3>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div :class="`${arabic?'arFont':'enFont'}`" style="line-height:1.6;font-size:1.2rem;">
                      {{i18n.new_thinking_methods}}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import innovationRadar from '@/components/innovationRadar'
import Notifications from '@/components/Notifications'
import MiniStat from '@/components/MiniStat'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {Notifications, MiniStat, innovationRadar},
  data() {
    return {
      loading:false,
      dialog:false,
      open:[],
      result:null,
      done:false,
      chartData:{
        labels: [
          'الاستمرار في تطوير المهارات' , //
          'الابداع', //
          'حل المشاكل', //
          'تقييم المخاطر',
          'المخاطرة',
          'بناء العلاقات' , 
          'التواصل',
          'التطبيق'
        ],
        // labels: [
        //     'Creativity', // 1
        //     'Problem-Solving', // 1
        //     'Continuous Improvement Skills', // 1
        //     'Risk Assessment', // 2
        //     'Risk-Taking Skills', // 2
        //     'Relationshipâ€“Building', // 3
        //     'Communication Skills', // 3
        //     'Implementation Skills' // 4
        // ],
        datasets: [{
            label: 'خريطة الابتكار',
            data: [20, 10, 18, 30, 22, 13, 28, 15],
            backgroundColor: 'rgba(2, 61, 102, 0.75)', // 'rgba(255, 99, 132, 0.8)',
            borderColor: 'rgb(2, 61, 102)',
            pointBackgroundColor: '#023d66',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255, 99, 132)'
        }],
      },
    }
  },
  methods: {
    
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },

    async loadHome(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let r = await this.$store.dispatch('getResource', {resource:'/user-answers'})
        console.log(r)
        this.done = r.count >= 69 ? true : false
        this.result = r
        this.chartData.datasets[0].data = r.result
        if(this.done && !this.$store.state.modelMenu.map(x=>x.text).includes('result')) {
          let r_tab = {icon:'insights', text:'result', path:'/results', roles:['master','superadmin', 'admin', 'user']}
          this.$store.state.modelMenu.push(r_tab)
        }
        try {
          gtag('event', `dashboard_visit`);
          gtag('event', `dashboard_visit_${this.user.account.name}`);
          gtag('event', `dashboard_visit_done_${this.done}`);
        } catch (error) {
          // console.log(error)
        }
        this.loading = false
        res(true)
      })
    }
    
  },
  computed:{
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      console.log(role)
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x&&x.roles.includes(role))
          }
        } else if(x&&x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x&&x.roles.includes(role))
      return this.$store.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  watch:{
    
  },
  async created(){
    await this.loadHome()
  },
}
</script>

<style>
.flagBtn {
  height: 80px !important;
}
</style>